import { AfterViewInit, ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { SurveyModule } from 'survey-angular-ui';
import { Model } from 'survey-core';
import 'survey-core/survey-core.min.css';

import { UiAtomButtonComponent } from '@shared/components/atoms/ui-atom-button/ui-atom-button.component';
import { UiAtomTextComponent } from '@shared/components/atoms/ui-atom-text/ui-atom-text.component';

export interface FormScoringDialogData {
  formName: string;
  schema: Record<string, unknown>;
  answers: Record<string, unknown>;
}

@Component({
  selector: 'ui-molecule-dialog-form-scoring',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslatePipe,
    SurveyModule,
    UiAtomButtonComponent,
    UiAtomTextComponent,
  ],
  templateUrl: './ui-molecule-dialog-form-scoring.component.html',
  styleUrl: './ui-molecule-dialog-form-scoring.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FormScoringDialogComponent implements AfterViewInit {
  surveyModel!: Model;
  isExpanded = false;

  constructor(
    public dialogRef: MatDialogRef<FormScoringDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormScoringDialogData,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.surveyModel = new Model(this.data.schema);
    // Set answers first so calculatedValues expressions resolve against the saved data.
    this.surveyModel.data = this.data.answers ?? {};
    this.surveyModel.mode = 'display';
    // doComplete() transitions state to 'completed', rendering completedHtml /
    // completedHtmlOnCondition with the recalculated scoring.
    this.surveyModel.doComplete();
    this.cdr.detectChanges();
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      this.dialogRef.updateSize('100vw', '100vh');
      this.dialogRef.addPanelClass('dialog-expanded');
      this.dialogRef.removePanelClass('dialog-safe-area');
    } else {
      this.dialogRef.updateSize('80vw', '90vh');
      this.dialogRef.removePanelClass('dialog-expanded');
      this.dialogRef.addPanelClass('dialog-safe-area');
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
